import Vue from 'vue'
import ElementUI from 'element-ui'
import CaDownload from '@/components/common/CaDownload.vue'

let dialogInstance = null

/**
 * 程序化显示 CA 下载弹窗
 * 可在非 Vue 组件（如 TS 工具类）中调用
 * @param {string} reason - 错误原因，'timeout' 或 'failed'
 */
export function showCaDialog(reason) {
  // 如果已有实例，直接显示
  if (dialogInstance) {
    dialogInstance.visible = true
    dialogInstance.reason = reason
    return
  }

  // 动态创建包含弹窗的 Vue 实例
  const DialogConstructor = Vue.extend({
    components: { CaDownload },
    data() {
      return {
        visible: true,
        reason: reason
      }
    },
    computed: {
      title() {
        return this.reason === 'timeout' ? 'CA证书助手连接超时' : 'CA证书助手连接失败'
      },
      message() {
        return this.reason === 'timeout'
          ? '证书助手连接超时，请确认证书助手已启动，如未安装请下载安装后重试。'
          : '无法连接到证书助手，请确认证书助手已正常运行，如未安装请下载安装后重试。'
      }
    },
    methods: {
      handleClose() {
        this.visible = false
      }
    },
    render(h) {
      return h(
        'el-dialog',
        {
          props: {
            title: this.title,
            visible: this.visible,
            width: '680px',
            appendToBody: true,
            closeOnClickModal: false
          },
          on: {
            'update:visible': (val) => { this.visible = val }
          }
        },
        [
          h('div', { style: { marginBottom: '16px' } }, [
            h('el-alert', {
              props: {
                title: this.message,
                type: 'warning',
                showIcon: true,
                closable: false
              }
            })
          ]),
          h('div', { style: { marginBottom: '8px', fontSize: '13px', color: '#606266' } }, '请下载并安装以下必要组件后重试：'),
          h('ca-download'),
          h(
            'div',
            { slot: 'footer', style: { textAlign: 'right' } },
            [
              h(
                'el-button',
                {
                  props: { type: 'primary' },
                  on: { click: this.handleClose }
                },
                '我已安装，重新连接'
              )
            ]
          )
        ]
      )
    }
  })

  // 挂载到 body
  const mountEl = document.createElement('div')
  document.body.appendChild(mountEl)
  dialogInstance = new DialogConstructor().$mount(mountEl)
}
